(() => {

  'use strict';



  const calculator = document.querySelector(

    'tile-calculator[data-calculator-type="livingstone"]'

  );



  if (!calculator) {

    console.warn('[Livingston Calculator] Calculator element not found.');

    return;

  }



  const dialog = calculator.querySelector('dialog');

  const addSectionButton = calculator.querySelector('#livingstoneAddSection');

  const areaContainer = calculator.querySelector('.area-container');

  const areaTemplate = document.querySelector('#areaCalculatorLivingstone');



  const coverageElement = calculator.querySelector('.livingstone-coverage');

  const requiredTilesElement = calculator.querySelector('.livingstone-required-tiles');

  const requiredPacksElement = calculator.querySelector('.livingstone-required-packs');

  const orderedTilesElement = calculator.querySelector('.livingstone-ordered-tiles');

  const orderSummary = calculator.querySelector('.livingstone-order-summary');

  const configError = calculator.querySelector('.livingstone-config-error');



  const quickAdd = calculator.querySelector('quick-add-to-cart-livingstone');

  const form = quickAdd ? quickAdd.querySelector('form') : null;

  const cartQuantityInput = form ? form.querySelector('input[name="quantity"]') : null;

  const addToCartButton = form ? form.querySelector('button[name="add"]') : null;



  const addedTilesElement = calculator.querySelector('.added-tiles');

  const addedTilesSingle = calculator.querySelector('.added-tiles-text--single');

  const addedTilesPlural = calculator.querySelector('.added-tiles-text--plural');



  const calculatorContent = calculator.querySelector('.tile-calculator__calculator');

  const finalScreen = calculator.querySelector('.tile-calculator__final-screen');



  const productSku = calculator.dataset.productSku || '';

  const packSize = parseInt(calculator.dataset.packSize || '0', 10);

  const packSizeSource = calculator.dataset.packSizeSource || '';

  const tileCoverageInSqFt = parseFloat(calculator.dataset.productCoverage || '0');

  const tileCoverageInSqM = tileCoverageInSqFt * 0.092903;



  let unit = calculator.dataset.mainUnits || 'in';

  let areas = [];



  const validConfiguration =

    Number.isFinite(tileCoverageInSqFt) &&

    tileCoverageInSqFt > 0 &&

    (Number.isInteger(packSize) && packSize > 0);



  function openCalculator() {

    if (!dialog) return;



    if (!dialog.open) {

      if (typeof dialog.showModal === 'function') {

        dialog.showModal();

      } else {

        dialog.setAttribute('open', '');

      }

    }



    document.body.style.overflow = 'hidden';

  }



  function closeCalculator() {

    if (!dialog) return;



    if (dialog.open && typeof dialog.close === 'function') {

      dialog.close();

    } else {

      dialog.removeAttribute('open');

    }



    document.body.style.overflow = '';

  }



  /*

   * IMPORTANT

   * Le bouton natif Smart Tiles s'attend à pouvoir appeler

   * openCalculator() sur <tile-calculator>.

   */

  calculator.openCalculator = openCalculator;

  calculator.closeCalculator = closeCalculator;



  function showCalculatorScreen() {

    if (calculatorContent) {

      calculatorContent.classList.remove('hidden');

    }



    if (finalScreen) {

      finalScreen.classList.add('hidden');

    }

  }



  function showFinalScreen() {

    if (calculatorContent) {

      calculatorContent.classList.add('hidden');

    }



    if (finalScreen) {

      finalScreen.classList.remove('hidden');

    }

  }



  function getSectionLetter(index) {

    if (!Number.isInteger(index) || index < 1 || index > 26) {

      return '';

    }



    return 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[index - 1];

  }



  function updateAreaIndexes() {

    areas.forEach((area, index) => {

      area.dataset.sectionIndex = String(index);



      const label = area.querySelector('.section-letter-id');



      if (label) {

        label.textContent = getSectionLetter(index + 1);

      }



      const deleteButton = area.querySelector('.delete-area');



      if (deleteButton) {

        deleteButton.style.visibility =

          areas.length === 1 ? 'hidden' : '';

      }

    });

  }



  function updateAreaUnitLabels(area) {

    const labels = area.querySelectorAll('.measure-input-label');



    labels.forEach((label) => {

      label.textContent = unit;

    });

  }



  function bindArea(area) {

    const widthInput = area.querySelector('input[name="width"]');

    const heightInput = area.querySelector('input[name="height"]');

    const surfaceInput = area.querySelector('input[name="surface"]');

    const deleteButton = area.querySelector('.delete-area');



    function updateArea() {

      const width = parseFloat(

        widthInput ? widthInput.value : '0'

      );



      const height = parseFloat(

        heightInput ? heightInput.value : '0'

      );



      const safeWidth =

        Number.isFinite(width)

          ? width

          : 0;



      const safeHeight =

        Number.isFinite(height)

          ? height

          : 0;



      if (surfaceInput) {

        surfaceInput.value =

          String(

            safeWidth *

            safeHeight

          );

      }



      updateTotalSurface();

    }



    if (widthInput) {

      widthInput.addEventListener(

        'input',

        updateArea

      );

    }



    if (heightInput) {

      heightInput.addEventListener(

        'input',

        updateArea

      );

    }



    if (deleteButton) {

      deleteButton.addEventListener(

        'click',

        () => {

          if (areas.length <= 1) {

            return;

          }



          area.remove();



          areas =

            areas.filter(

              (item) => item !== area

            );



          updateAreaIndexes();



          updateTotalSurface();

        }

      );

    }



    updateAreaUnitLabels(area);

  }



  function createNewArea() {

    if (!areaTemplate || !areaContainer) {

      return;

    }



    const fragment =

      areaTemplate.content.cloneNode(true);



    const area =

      fragment.querySelector(

        'area-calculator-livingstone'

      );



    if (!area) {

      return;

    }



    areaContainer.appendChild(fragment);



    areas.push(area);



    bindArea(area);



    updateAreaIndexes();

  }



  function resetOrderState() {

    if (cartQuantityInput) {

      cartQuantityInput.value = '0';

    }



    if (addToCartButton) {

      addToCartButton.disabled = true;

    }



    if (requiredPacksElement) {

      requiredPacksElement.textContent = '0';

    }



    if (orderedTilesElement) {

      orderedTilesElement.textContent = '0';

    }



    if (addedTilesElement) {

      addedTilesElement.textContent = '0';

    }



    if (orderSummary) {

      orderSummary.classList.add('hidden');

    }

  }



  function resetCalculator() {

    areas.forEach((area, index) => {

      if (index === 0) {

        const widthInput =

          area.querySelector(

            'input[name="width"]'

          );



        const heightInput =

          area.querySelector(

            'input[name="height"]'

          );



        const surfaceInput =

          area.querySelector(

            'input[name="surface"]'

          );



        if (widthInput) {

          widthInput.value = '';

        }



        if (heightInput) {

          heightInput.value = '';

        }



        if (surfaceInput) {

          surfaceInput.value = '0';

        }

      } else {

        area.remove();

      }

    });



    areas = areas.slice(0, 1);



    updateAreaIndexes();



    if (coverageElement) {

      coverageElement.textContent = '0';

    }



    if (requiredTilesElement) {

      requiredTilesElement.textContent = '0';

    }



    resetOrderState();

  }



  function getTotalRawSurface() {

    let total = 0;



    calculator

      .querySelectorAll('.area-surface')

      .forEach((input) => {

        const value =

          parseFloat(input.value);



        if (Number.isFinite(value)) {

          total += value;

        }

      });



    return total;

  }



  function calculateRequiredTiles(

    surface,

    coveragePerTile

  ) {

    if (

      !Number.isFinite(surface) ||

      !Number.isFinite(coveragePerTile) ||

      surface <= 0 ||

      coveragePerTile <= 0

    ) {

      return 0;

    }



    const surfaceIncludingWaste =

      surface * 1.10;



    return Math.ceil(

      surfaceIncludingWaste /

      coveragePerTile

    );

  }



  function calculateOrder(requiredTiles) {

    if (

      !requiredTiles ||

      requiredTiles <= 0 ||

      !validConfiguration

    ) {

      return {

        requiredTiles: 0,

        packs: 0,

        orderedTiles: 0

      };

    }



    const packs =

      Math.ceil(

        requiredTiles /

        packSize

      );



    return {

      requiredTiles,

      packs,

      orderedTiles:

        packs *

        packSize

    };

  }



  function updateOrderDisplay(order) {

    if (!order || order.packs <= 0) {

      resetOrderState();

      return;

    }



    if (requiredPacksElement) {

      requiredPacksElement.textContent =

        String(order.packs);

    }



    if (orderedTilesElement) {

      orderedTilesElement.textContent =

        String(order.orderedTiles);

    }



    if (orderSummary) {

      orderSummary.classList.remove('hidden');

    }



    /*

     * CRITIQUE :

     * Shopify quantity = nombre de PACKS.

     */

    if (cartQuantityInput) {

      cartQuantityInput.value =

        String(order.packs);

    }



    if (addToCartButton) {

      addToCartButton.disabled = false;

    }



    if (addedTilesElement) {

      addedTilesElement.textContent =

        String(order.orderedTiles);

    }



    if (order.orderedTiles === 1) {

      if (addedTilesSingle) {

        addedTilesSingle.classList.remove('hidden');

      }



      if (addedTilesPlural) {

        addedTilesPlural.classList.add('hidden');

      }

    } else {

      if (addedTilesSingle) {

        addedTilesSingle.classList.add('hidden');

      }



      if (addedTilesPlural) {

        addedTilesPlural.classList.remove('hidden');

      }

    }

  }



  function updateTotalSurface() {

    if (!validConfiguration) {

      resetOrderState();

      return;

    }



    const rawSurface =

      getTotalRawSurface();



    if (

      !Number.isFinite(rawSurface) ||

      rawSurface <= 0

    ) {

      if (coverageElement) {

        coverageElement.textContent = '0';

      }



      if (requiredTilesElement) {

        requiredTilesElement.textContent = '0';

      }



      resetOrderState();



      return;

    }



    let displayedSurface = 0;

    let requiredTiles = 0;



    if (unit === 'cm') {

      const squareMeters =

        rawSurface *

        0.0001;



      displayedSurface =

        squareMeters;



      requiredTiles =

        calculateRequiredTiles(

          squareMeters,

          tileCoverageInSqM

        );

    } else {

      const squareFeet =

        rawSurface /

        144;



      displayedSurface =

        squareFeet;



      requiredTiles =

        calculateRequiredTiles(

          squareFeet,

          tileCoverageInSqFt

        );

    }



    if (coverageElement) {

      coverageElement.textContent =

        String(

          Math.round(

            displayedSurface *

            10

          ) / 10

        );

    }



    if (requiredTilesElement) {

      requiredTilesElement.textContent =

        String(requiredTiles);

    }



    updateOrderDisplay(

      calculateOrder(

        requiredTiles

      )

    );

  }



  function updateUnits(newUnit) {

    unit = newUnit;



    areas.forEach((area) => {

      const widthInput =

        area.querySelector(

          'input[name="width"]'

        );



      const heightInput =

        area.querySelector(

          'input[name="height"]'

        );



      const surfaceInput =

        area.querySelector(

          'input[name="surface"]'

        );



      if (widthInput) {

        widthInput.value = '';

      }



      if (heightInput) {

        heightInput.value = '';

      }



      if (surfaceInput) {

        surfaceInput.value = '0';

      }



      updateAreaUnitLabels(area);

    });



    const surfaceUnits =

      calculator.querySelector(

        '.surface-units'

      );



    const translations =

      window.tileCalculatorLivingstone;



    const key =

      newUnit === 'cm'

        ? 'sq_m'

        : 'sq_ft';



    if (

      surfaceUnits &&

      translations &&

      translations.units &&

      translations.units[key]

    ) {

      surfaceUnits.innerHTML =

        translations.units[key];

    }



    updateTotalSurface();

  }



  function showConfigurationError() {

    if (configError) {

      configError.classList.remove('hidden');

    }



    if (addToCartButton) {

      addToCartButton.disabled = true;

    }



    console.error(

      '[Livingston Calculator] Invalid product configuration',

      {

        sku: productSku,

        packSize,

        packSizeSource,

        coverage:

          tileCoverageInSqFt

      }

    );

  }



  async function updateMiniCart() {

    try {

      const response =

        await fetch(

          `${Shopify.routes.cart_url}.js`,

          {

            headers: {

              'Content-Type':

                'application/json'

            }

          }

        );



      const cart =

        await response.json();



      if (

        typeof Shopify !== 'undefined' &&

        Shopify.productPage &&

        typeof Shopify.productPage

          .updateMiniCartCount === 'function'

      ) {

        Shopify.productPage

          .updateMiniCartCount(

            cart.item_count

          );

      }

    } catch (error) {

      console.error(

        '[Livingston Calculator] Mini-cart update error',

        error

      );

    }

  }



  async function handleAddToCart(event) {

    event.preventDefault();



    if (!form || !addToCartButton) {

      return;

    }



    const spinner =

      quickAdd.querySelector(

        '.svg-spinner'

      );



    const buttonText =

      quickAdd.querySelector(

        '.add-to-cart-text'

      );



    const addedText =

      quickAdd.querySelector(

        '.add-to-cart-added-text'

      );



    const errorMessage =

      calculator.querySelector(

        '.add-to-cart-error-message'

      );



    const formData =

      new FormData(form);



    const variantId =

      parseInt(

        formData.get('id'),

        10

      );



    const quantity =

      parseInt(

        formData.get('quantity'),

        10

      );



    if (

      !variantId ||

      !quantity ||

      quantity <= 0

    ) {

      return;

    }



    addToCartButton

      .classList

      .add('loading');



    addToCartButton

      .setAttribute(

        'aria-disabled',

        'true'

      );



    if (spinner) {

      spinner.classList.remove('hidden');

    }



    if (buttonText) {

      buttonText.classList.add('hidden');

    }



    try {

      const response =

        await fetch(

          Shopify.routes.cart_add_url,

          {

            method: 'POST',



            headers: {

              'Content-Type':

                'application/json',



              Accept:

                'application/json'

            },



            body:

              JSON.stringify({

                items: [

                  {

                    id: variantId,

                    quantity

                  }

                ]

              })

          }

        );



      const result =

        await response.json();



      if (

        !response.ok ||

        result.status

      ) {

        if (errorMessage) {

          errorMessage.innerHTML =

            result.description ||

            'Unable to add this item to cart.';



          errorMessage.classList.remove(

            'hidden'

          );

        }



        return;

      }



      if (errorMessage) {

        errorMessage.classList.add(

          'hidden'

        );

      }



      await updateMiniCart();



      if (addedText) {

        addedText.classList.remove(

          'hidden'

        );

      }



      window.setTimeout(

        () => {

          if (addedText) {

            addedText.classList.add(

              'hidden'

            );

          }



          showFinalScreen();

        },

        700

      );

    } catch (error) {

      console.error(

        '[Livingston Calculator] Add-to-cart error',

        error

      );



      if (errorMessage) {

        errorMessage.innerHTML =

          'Unable to add this item to cart.';



        errorMessage.classList.remove(

          'hidden'

        );

      }

    } finally {

      addToCartButton

        .classList

        .remove('loading');



      addToCartButton

        .removeAttribute(

          'aria-disabled'

        );



      if (spinner) {

        spinner.classList.add(

          'hidden'

        );

      }



      if (buttonText) {

        buttonText.classList.remove(

          'hidden'

        );

      }

    }

  }



  if (addSectionButton) {

    addSectionButton.addEventListener(

      'click',

      (event) => {

        event.preventDefault();



        createNewArea();

      }

    );

  }



  calculator

    .querySelectorAll(

      'input[name="livingstone-unit"]'

    )

    .forEach((radio) => {

      radio.addEventListener(

        'change',

        () => {

          updateUnits(

            radio.value

          );

        }

      );

    });



  calculator

    .querySelectorAll(

      '.close-calculator'

    )

    .forEach((button) => {

      button.addEventListener(

        'click',

        () => {

          closeCalculator();



          if (

            button.dataset.resetValues ===

            'true'

          ) {

            resetCalculator();



            showCalculatorScreen();

          }

        }

      );

    });



  if (form) {

    form.addEventListener(

      'submit',

      handleAddToCart

    );

  }



  /*

   * FALLBACK D'OUVERTURE

   *

   * Le bouton visible reste celui du snippet

   * product-add-to-cart natif.

   *

   * Si le script historique du thème ne trouve

   * plus correctement la calculatrice, on détecte

   * directement le clic sur le bouton.

   */

  document.addEventListener(

    'click',

    (event) => {

      const trigger =

        event.target.closest(

          'button, a'

        );



      if (!trigger) {

        return;

      }



      /*

       * Ne jamais intercepter les boutons

       * qui sont eux-mêmes dans la popup.

       */

      if (

        trigger.closest(

          'tile-calculator'

        )

      ) {

        return;

      }



      const triggerSignature = [

        trigger.id || '',



        typeof trigger.className ===

          'string'

          ? trigger.className

          : '',



        trigger.getAttribute(

          'data-action'

        ) || '',



        trigger.getAttribute(

          'aria-label'

        ) || '',



        trigger.textContent || ''

      ]

        .join(' ')

        .toLowerCase();



      const looksLikeCalculatorTrigger =

        triggerSignature.includes(

          'tile-calculator'

        ) ||

        triggerSignature.includes(

          'tile calculator'

        ) ||

        triggerSignature.includes(

          'calculate tiles'

        ) ||

        triggerSignature.includes(

          'calculateur'

        );



      if (!looksLikeCalculatorTrigger) {

        return;

      }



      event.preventDefault();



      openCalculator();

    }

  );



  createNewArea();



  if (!validConfiguration) {

    showConfigurationError();

  }



  console.log(

    '[Livingston Calculator] Ready',

    {

      sku: productSku,

      packSize,

      coverage:

        tileCoverageInSqFt,

      unit

    }

  );

})();
